import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import Navigation from '../components/Navigation.jsx'
import Footer from '../components/Footer.jsx'
import EventDetailFull from '../components/EventDetailFull.jsx'
import { EventSchema } from '../components/SchemaOrg.jsx'
import { useSavedItems } from '../hooks/useSavedItems.js'

export default function EventPage() {
    const { id } = useParams()
    const [event, setEvent] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')

    const { toggleSaveItem, isSaved } = useSavedItems()

    useEffect(() => {
        const fetchEvent = async () => {
            setLoading(true)
            setError('')
            
            try {
                // In a real app, this would be an API call
                // For now, we'll need to implement proper backend endpoint
                const response = await fetch(`/api/event/${id}`)
                
                if (!response.ok) {
                    throw new Error('Event not found')
                }
                
                const data = await response.json()
                setEvent({ ...data, searchType: 'events' })
            } catch (err) {
                setError(err.message || 'Failed to load event')
            } finally {
                setLoading(false)
            }
        }

        if (id) {
            fetchEvent()
        }
    }, [id])

    return (
        <>
            <EventSchema event={event} />
            <div className="flex min-h-screen flex-col bg-slate-50">
                <Navigation />

            <main className="flex flex-1 flex-col px-4 py-6 sm:px-6 lg:px-16">
                <div className="mb-6">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-logo-pink transition hover:text-purple-600"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            className="h-5 w-5"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
                            />
                        </svg>
                        Back to search
                    </Link>
                </div>

                {loading && (
                    <div className="rounded-xl border border-purple-200 bg-white p-8 text-center shadow-sm">
                        <p className="text-slate-600">Loading event...</p>
                    </div>
                )}

                {error && (
                    <div className="rounded-xl border border-red-200 bg-red-50 p-8 text-center shadow-sm">
                        <p className="text-red-700">{error}</p>
                        <Link
                            to="/"
                            className="mt-4 inline-block text-logo-pink transition hover:text-purple-600"
                        >
                            Return to home page
                        </Link>
                    </div>
                )}

                {!loading && !error && event && (
                    <EventDetailFull
                        event={event}
                        isSaved={isSaved(event.id)}
                        onToggleSave={toggleSaveItem}
                    />
                )}
            </main>

            <Footer />
            </div>
        </>
    )
}
